<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title> Licencias Oficiales Colectivas </v-card-title>
          <v-card-subtitle>
            Administre las Licencias Oficiales Colectivas a las que el personal se encuentra inscrito.
          </v-card-subtitle>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="10">
                  <BaseSelect v-model="selectedLoc" :label="'Seleccione una Licencia'" :items="locOptions" />
                </v-col>
                <v-col cols="2">
                  <TextButton :loading="loading" :disabled="loading || !selectedLoc" @click="handleSavePersonalLoc">
                    Vincular
                  </TextButton>
                </v-col>
                <v-col cols="12">
                  <LocsPersonalTable :locs-personal="locsPersonal" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseSelect from '../../base/BaseSelect.vue'
import DateAdapter from '@/utils/DateAdapter'
import { API_DATE_FORMAT } from '@/const'
import TextButton from '@components/base/TextButton.vue'
import LocsPersonalTable from './LocsPersonalTable.vue'

export default {
  components: {
    BaseSelect,
    TextButton,
    LocsPersonalTable,
  },

  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      selectedLoc: null,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('personalLoc', { locsPersonal: 'getPersonalLoc' }),
    ...mapGetters('licenciaOficialColectiva', { locs: 'getLocs' }),

    locOptions() {
      return this.locs
        .map((loc) => ({
          title: `Licencia #${loc.noLicencia} - dada de alta el ${new DateAdapter(
            loc.fechaAlta,
            API_DATE_FORMAT
          ).toHumanReadable()}`,
          id: loc.idLoc,
        }))
        .filter((loc) => !this.locsPersonal.some(({ fk_idLoc }) => fk_idLoc === loc.id))
    },
  },

  mounted() {
    this.fetchLocs()
    this.fetchPersonalLoc(this.idPersonal)
  },

  methods: {
    ...mapActions('personalLoc', ['fetchPersonalLoc', 'savePersonalLoc']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),

    async handleSavePersonalLoc() {
      this.loading = true
      await this.savePersonalLoc({ idPersonal: this.idPersonal, fk_idLoc: this.selectedLoc })
      await this.fetchPersonalLoc(this.idPersonal)
      this.selectedLoc = null
      this.loading = false
    },
  },
}
</script>
